import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

import styles from './RouteError.module.css';
import { NoIndex } from './seo';
import { hardReload, isChunkLoadError } from './staleChunk';

/**
 * Error de ruta (incluye el 404 y un chunk que no cargó por mala señal). Sin dependencias pesadas:
 * tiene que poder pintarse aunque falle la carga de un grupo de rutas.
 */
export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  const title = notFound ? 'No encontramos esta página' : 'Algo no cargó bien';
  const text = notFound
    ? 'Puede que el enlace esté incompleto o que la página ya no exista.'
    : 'Revisa tu conexión o inténtalo de nuevo en un momento. Tus sellos y calificaciones están a salvo.';

  return (
    <main className={`paper ${styles.page}`}>
      <title>{`${title} · Parche Cafetero`}</title>
      {notFound && <NoIndex />}
      <div className={styles.box} role={notFound ? undefined : 'alert'}>
        <h1 className={`serif ${styles.title}`}>{title}</h1>
        <p className={styles.text}>{text}</p>
        {!notFound && <p className={`num ${styles.code}`}>Código de error: PC-{isRouteErrorResponse(error) ? error.status : 'APP'}</p>}
        <div className={styles.actions}>
          {!notFound && (
            <button type="button" className="btn btn-p" onClick={() => (isChunkLoadError(error) ? void hardReload() : window.location.reload())}>
              Reintentar
            </button>
          )}
          <Link to="/" className={notFound ? 'btn btn-p' : 'btn btn-g'}>
            Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}

export function NotFoundPage() {
  return (
    <main className={`paper ${styles.page}`}>
      <title>No encontramos esta página · Parche Cafetero</title>
      <NoIndex />
      <div className={styles.box}>
        <h1 className={`serif ${styles.title}`}>No encontramos esta página</h1>
        <p className={styles.text}>Puede que el enlace esté incompleto o que la página ya no exista.</p>
        <div className={styles.actions}>
          <Link to="/" className="btn btn-p">
            Volver al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}
